exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol{counter-reset:item;padding-left:10px}li{display:block}li:before{content:counters(item,\".\") \". \";counter-increment:item}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/lib/tool/tools/home-page/home-page.component.styl
// module id = 1182
// module chunks = 0